(function () {
  const STORAGE_KEY = 'vtwonen_recently_viewed_products';
  const MAX_STORED_PRODUCTS = 12;
  const PRODUCT_CARD_SECTION_ID = 'recently-viewed-product-card';

  function getRecentlyViewedHandles() {
    try {
      const storedProducts = localStorage.getItem(STORAGE_KEY);

      if (!storedProducts) {
        return [];
      }

      const handles = JSON.parse(storedProducts);

      return Array.isArray(handles) ? handles : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecentlyViewedProduct(handle) {
    if (!handle) {
      return;
    }

    const existingHandles = getRecentlyViewedHandles();

    const updatedHandles = existingHandles.filter(function (storedHandle) {
      return storedHandle !== handle;
    });

    updatedHandles.unshift(handle);

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(updatedHandles.slice(0, MAX_STORED_PRODUCTS))
      );
    } catch (error) {
      console.warn('Recently viewed products could not be saved.', error);
    }
  }

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  async function getProductCard(handle) {
    try {
      const root = getShopifyRoot();
      const productUrl =
        root +
        'products/' +
        encodeURIComponent(handle) +
        '?section_id=' +
        PRODUCT_CARD_SECTION_ID;

      const response = await fetch(productUrl);

      if (!response.ok) {
        return null;
      }

      const html = await response.text();

      if (!html.trim()) {
        return null;
      }

      const template = document.createElement('template');

      template.innerHTML = html.trim();

      return template.content.querySelector('li.splide__slide');
    } catch (error) {
      console.warn('Recently viewed product could not be loaded.', error);
      return null;
    }
  }

  function addSliderSpacing(productCards) {
    productCards.forEach(function (productCard, index) {
      if (index === 0) {
        productCard.classList.add(
          'u-pl-14',
          'xl:u-pl-0',
          '!u-box-content'
        );
      }

      if (index === productCards.length - 1) {
        productCard.classList.add(
          'u-pr-14',
          'xl:u-pr-0',
          '!u-box-content'
        );
      }
    });
  }

  async function renderRecentlyViewedProducts(container) {
    const currentProductHandle = container.dataset.currentProductHandle;
    const maxProducts = Number(container.dataset.maxProducts || 8);

    let handles = getRecentlyViewedHandles();

    if (currentProductHandle) {
      handles = handles.filter(function (handle) {
        return handle !== currentProductHandle;
      });
    }

    handles = handles.slice(0, maxProducts);

    if (!handles.length) {
      return;
    }

    const productCards = await Promise.all(
      handles.map(function (handle) {
        return getProductCard(handle);
      })
    );

    const validProductCards = productCards.filter(function (productCard) {
      return productCard !== null;
    });

    if (!validProductCards.length) {
      return;
    }

    const sliderTemplate = container.querySelector(
      '[data-recently-viewed-slider-template]'
    );

    if (!sliderTemplate) {
      return;
    }

    const sliderFragment = sliderTemplate.content.cloneNode(true);

    const productList = sliderFragment.querySelector(
      '[data-recently-viewed-list]'
    );

    if (!productList) {
      return;
    }

    addSliderSpacing(validProductCards);

    validProductCards.forEach(function (productCard) {
      productList.appendChild(productCard);
    });

    sliderTemplate.replaceWith(sliderFragment);

    container.classList.remove('u-hidden');
  }

  function registerCurrentProduct() {
    const recentlyViewedSection = document.querySelector(
      '[data-recently-viewed-products]'
    );

    if (!recentlyViewedSection) {
      return;
    }

    const productHandle = recentlyViewedSection.dataset.currentProductHandle;

    if (!productHandle) {
      return;
    }

    saveRecentlyViewedProduct(productHandle);
  }

  document.addEventListener('DOMContentLoaded', function () {
    registerCurrentProduct();

    document
      .querySelectorAll('[data-recently-viewed-products]')
      .forEach(function (container) {
        renderRecentlyViewedProducts(container);
      });
  });
})();